import { pipelineSteps, pipelineMiniFaqs } from '../../content/methodology';

const colorMap: Record<string, string> = {
  blue: '#185FA5',
  gray: '#888780',
  purple: '#7F77DD',
  coral: '#D85A30',
  teal: '#1B7A6A',
};

export function PipelineDiagram() {
  return (
    <section className="pipeline-diagram">
      <h3>Jak probíhá posouzení návrhu</h3>
      <div className="pipeline-diagram__steps">
        {pipelineSteps.map((step, idx) => (
          <div key={step.number} className="pipeline-diagram__step-wrapper">
            <div className="pipeline-diagram__step" style={{ borderLeftColor: colorMap[step.color] }}>
              <div className="pipeline-diagram__step-number" style={{ background: colorMap[step.color] }}>{step.number}</div>
              <div className="pipeline-diagram__step-body">
                <div className="pipeline-diagram__step-title">{step.title}</div>
                <div className="pipeline-diagram__step-oneliner">{step.oneliner}</div>
                <p className="pipeline-diagram__step-detail">{step.detail}</p>
                {step.techNote && (
                  <p className="pipeline-diagram__step-tech">Technicky: {step.techNote}</p>
                )}
              </div>
            </div>
            {idx < pipelineSteps.length - 1 && (
              <div className="pipeline-diagram__arrow" aria-hidden="true">→</div>
            )}
          </div>
        ))}
      </div>
      <div className="pipeline-diagram__mini-faq">
        {pipelineMiniFaqs.map((faq) => (
          <div key={faq.q} className="pipeline-diagram__mini-faq-item">
            <strong>{faq.q}</strong>
            <p>{faq.a}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
